/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Clipboard Copy (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgClipboardCopy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M38 35h-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1M38 35a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2m-6 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m0 0h2a2 2 0 0 1 2 2v3m2 4H40m0 0 3-3m-3 3 3 3"
    />
  </svg>
);
export default SvgClipboardCopy;
